import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ConfigService } from 'app/app-config.service';
import { DCarbonizeAppConfig } from 'app/@types/shared/app-config';
import { environment } from 'environments/environment';
import { CustomTranslateService } from '@services/common/custom-translate.service';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-authentication',
    templateUrl: './authentication.component.html',
    styleUrls: ['./authentication.component.scss'],
    standalone: false,
})
export class AuthenticationComponent implements OnInit, OnDestroy {
    public hasLanguageMenu: boolean;
    public config: DCarbonizeAppConfig = {} as DCarbonizeAppConfig;
    public selectedLocale: string = 'en';
    currentAppVersion: string = environment.appVersion;
    readonly currentYear = new Date().getFullYear();
    public src = 'assets/images/pages/auth/registerWaves.png';
    isRegister: boolean = false;
    private routerSubscription: Subscription | null = null;

    /** The waves drawn behind the welcome text, back to front. */
    readonly waves = [1, 2, 3];
    /** The product's four steps, each but the last pointing to the next with an arrow. */
    readonly features = [
        { key: 'measure', icon: 'square_foot', arrow: 'assets/images/onboarding/arrow1white.svg' },
        { key: 'analyze', icon: 'query_stats', arrow: 'assets/images/onboarding/arrow2white.svg' },
        { key: 'reduce', icon: 'trending_down', arrow: 'assets/images/onboarding/arrow3white.svg' },
        { key: 'report', icon: 'assignment', arrow: null },
    ];

    constructor(
        private route: ActivatedRoute,
        public configService: ConfigService,
        private translateService: CustomTranslateService,
        private router: Router,
    ) {
        this.hasLanguageMenu = !!this.route.snapshot.firstChild?.data['haslanguageMenu'];
    }

    ngOnInit() {
        this.config = this.configService.getConfig;
        this.route.queryParamMap.subscribe((paramsMaps) => {
            if (!paramsMaps.has('locale')) {
                return;
            }
            const locale = paramsMaps.get('locale');
            if (!locale || !this.translateService.langs.includes(locale)) {
                return;
            }
            this.translateService.use(locale);
        });
    }

    ngOnDestroy() {
        if (this.routerSubscription) {
            this.routerSubscription.unsubscribe();
        }
    }

    public sendEmail() {
        const mailTo = this.configService.getClient.support?.mailDcarbonize;
        const mail = `mailto:${mailTo}`;
        window.open(mail, 'emailWindow');
    }
}
